//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const EnforceContentSecurityPolicy: FeatureFlag = {"Id":"EnforceContentSecurityPolicy","Label":"Enforce Content Security Policy","Impact":"For security, instruct the browser to only load data from whitelist of location","Mode":3,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
